<template>
  <div>
    <div class="padding-container-sm">
      <!-- <v-page-header> -->
      <div slot="header">
        <div class="row">
          <div class="col-md-10">
            <div class="col d-flex p-0 pb-2">
              <div class="d-flex searchFilter">
                <b-input-group size="md border-right flex-grow-1">
                  <b-input-group-text slot="append" class="bg-white">
                    <strong>
                      <i class="ion-md-search" @click="onSearchText" />
                    </strong>
                  </b-input-group-text>
                  <b-form-input
                    class="border-right-0"
                    :value="filter.patient"
                    v-model="pateintSearchText"
                    placeholder="Search for patient or ID"
                    @keyup.enter.native="onSearchText"
                  />
                </b-input-group>
                <b-input-group size="md border-right flex-grow-1">
                  <b-input-group-text slot="append" class="bg-white">
                    <strong>
                      <i class="ion-md-search" @click="onCarePlanSearch" />
                    </strong>
                  </b-input-group-text>
                  <b-form-input
                    class="border-right-0"
                    :value="filter.careplan"
                    v-model="carePlanSearchText"
                    placeholder="Search for careplan or ID"
                    @keyup.enter.native="onCarePlanSearch"
                  />
                </b-input-group>
              </div>
              <div class="btn btn-link" @click="resetFilters">
                <strong>
                  <i class="ion-md-refresh mr-1" />
                </strong>Reset
              </div>
            </div>
          </div>
          <div class="col-md-2 pb-2 text-right">
            <b-form-select
              v-validate="'required'"
              v-model="filter.day"
              name="plan_duration"
              @change="dayFilter()"
            >
              <option selected value="all">All Days</option>
              <option
                v-for="planDuration in plan_duration"
                :key="planDuration.index"
              >{{ planDuration.value }}</option>
            </b-form-select>
          </div>
        </div>
      </div>
      <div />
      <!-- </v-page-header> -->
      <v-table :options="tableProps" :total-count="Number(totalCount)" :data="assessments">
        <template slot="name" slot-scope="slotProps">
          <div class="align-items-center d-flex patient-name-content">
            <img
              :src="require(`@/assets/image/${
                slotProps.data.datum && slotProps.data.datum.gender === 'male' ?
                  'boy':
                  'girl'
              }.svg`)"
              width="35"
              height="35"
              :alt="slotProps.data.datum.first_name"
              v-b-tooltip.hover
              :title="slotProps.data.datum.first_name"
            />
            <div
              class="d-flex flex-column justify-content-center align-items-center"
              v-if="slotProps"
            >
              <span>
                {{ slotProps.data.datum.first_name | capitalizefirst }}
                {{ slotProps.data.datum.last_name | capitalizefirst }}
              </span>
              <span>
                Cycle-{{ slotProps.data.datum.current_cycle }}
                | Day- {{ slotProps.data.datum.day }}
              </span>
               <span class="btn btn-link" @click="redirectToMessage(slotProps.data.datum.mr_id)">
                  Send Message
                </span>
            </div>
          </div>
        </template>

        <template slot="responsesCount" slot-scope="slotProps">
          <div class="d-flex flex-column justify-content-center align-items-center p-2 col">
            <span class="unassigned w-100">
              <b>{{ respCount(slotProps.data.datum.patient_assessment) }} /</b>
              <b>{{ slotProps.data.datum.patient_assessment.length }}</b>
            </span>
          </div>
        </template>

        <template slot="description" slot-scope="slotProps">
          <div
            class="d-flex flex-row justify-content-around alertCell border-bottom p-0"
            v-for="assResponses in slotProps.data.datum.patient_assessment"
            :key="assResponses.index"
          >
          <!-- {{assResponses}} -->
            <div class="d-flex flex-column justify-content-center align-items-center w-50 p-2 col">
              <span class="unassigned w-100">
                <span v-if="assResponses.input_type !='Boolean'">
                  <span v-if="Number(assResponses.value) >= Number(assResponses.threshold) && assResponses.input_type !== 'MultipleChoice'">
                    <b class="text-danger">{{ assResponses.name }} :</b>
                    <b class="text-danger">{{ (assResponses.value) }}</b>
                  </span>
                   <span v-else-if="assResponses.input_type === 'MultipleChoice' && assResponses.value">
                    <b class="text-danger">{{ assResponses.name }} :</b>
                    <b class="text-danger">{{ (assResponses.value) }}</b>
                  </span>
                  <span v-else>
                    <b>{{ assResponses.name }} :</b>
                    <b v-if="assResponses.value">{{ assResponses && assResponses.value }}</b>
                    <b v-else>no response</b>
                  </span>
                </span>
                <span v-else>
                <span v-if="assResponses.value && Number(assResponses.value) === Number(assResponses.threshold)">
                    <b class="text-danger">{{ assResponses.name }} :</b>
                    <b class="text-danger">{{ assResponses.value }}</b>
                  </span>

                  <span v-else>
                    <b>{{ assResponses.name }} :</b>
                    <b v-if="assResponses.value">{{ assResponses && assResponses.value }}</b>
                    <b v-else>no response</b>
                  </span>
                </span>
              </span>
              <span
                v-if="assResponses.value"
                class="align-items-center d-flex"
              >{{ dateFormate(getFormattedDate(assResponses.updated_at, dateTime)) }}</span>
              <span
                v-else
                class="align-items-center d-flex"
              >{{ dateFormate(getFormattedDate(slotProps.data.datum.assessment_date, dateTime)) }}</span>
            </div>
          </div>
        </template>
        <template slot="contact" slot-scope="slotProps">
          <div
            v-if="slotProps"
            class="d-flex flex-column justify-content-between align-items-center p-2"
          >
            <div
              v-if="slotProps.data.datum.email"
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <span>{{ slotProps.data.datum.mobile_no }}</span>
              <span>{{ slotProps.data.datum.email }}</span>
            </div>
          </div>
        </template>

        <template slot="alert-info-header">
          <div class="d-flex flex-row justify-content-around">
            <div>Side Effects/Symptoms Responses</div>
          </div>
        </template>
      </v-table>
    </div>
    <v-resolution ref="resolution" :onResolve="fetchAssessments" />
    <v-loader :isLoading="isLoading" />
  </div>
</template>

<script>
import VTable from "@/components/table/index.vue";
import { mapGetters } from "vuex";
import VResolution from "@/components/resolution/Resolution.vue";
import VLoader from "@/components/loader/index.vue";
import careplan from "@/mixins/careplan";
import dateFormate from "@/mixins/dateFormate";

export default {
  name: "Users",
  components: {
    VTable,
    VResolution,
    VLoader
  },
  mixins: [careplan,dateFormate],
  data() {
    return {
      patient: {},
      assessmentdays: {
        1: 1,
        2: 2,
        3: 3
      },
      pateintSearchText: "",
      carePlanSearchText: "",
      filter: {
        pageNo: 1,
        limit: 5,
        patient: "",
        careplan: "",
        searchValue: "",
        day: "all"
      },
      tableProps: {
        columns: [
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {
              class: "text-left"
            },
            cellSlot: {
              name: "name"
            },
            dataKey: "first_name",
            dataType: String,
            label: "Patient Name"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            dataKey: "mr_id",
            dataType: String,
            label: "Patient ID"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },

            cellSlot: {
              name: "responsesCount"
            },
            dataType: String,
            label: "Responses"
          },
          {
            headerCellProps: {
              class: "header-cell",
              colspan: 2
            },
            headerCellSlot: {
              name: "alert-info-header"
            },
            cellSlot: {
              name: "description"
            },
            cellProps: {
              colspan: 2,
              class: "alertCol p-0"
            },
            dataKey: "description",
            dataType: String,
            label: "Side Effects/Symptoms Responses"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            cellSlot: {
              name: "contact"
            },
            dataKey: "email",
            dataType: String,
            label: "Contact"
          }
        ],
        enableSelect: false,
        onPageChange: this.onPageChange,
        page: 1,
        rowProps: {},
        rowsPerPage: 5,
        title: "All users"
      }
    };
  },
  computed: {
    ...mapGetters({
      assessments: "assessments/getAssessments",
      totalCount: "assessments/getTotalCount",
      isLoading: "assessments/getIsLoading",
    })
  },
  watch: {
    filter: {
      handler: "fetchAssessments",
      immediate: true
    }
  },
  methods: {
    onPageChange(pageNo) {
      this.tableProps.page = pageNo;
      this.filter = {
        ...this.filter,
        pageNo,
        limit: 5
      };
    },
    onSearchText() {
      this.filter = {
        ...this.filter,
        pageNo: "",
        patient: this.pateintSearchText.toLowerCase()
      };
    },
    onCarePlanSearch() {
      this.filter = {
        ...this.filter,
        careplan: this.carePlanSearchText.toLowerCase()
      };
    },
    dayFilter() {
      this.filter = {
        ...this.filter
      };
    },
    respCount(assessments) {
      const count = assessments.filter(item => item.value !== null);
      return count.length;
    },
    fetchAssessments() {
      this.$store.dispatch("assessments/getAssessments", this.filter);
    },
    onResolve(alertDetails) {
      this.$refs.resolution.showResolution(alertDetails);
    },
    setStatus(currentStatus) {
      if (this.filter.status !== currentStatus) {
        this.filter = {
          ...this.filter,
          status: currentStatus,
          filterType: currentStatus.toLowerCase()
        };
      }
    },
    viewCarePlanDetails(alertDetails) {
      const id = alertDetails.careplan_id;
      this.$router.push({
        name: "careplan.view",
        params: { id }
      });
    },
    viewPatientProgress(patient) {
      // eslint-disable-next-line camelcase
      const { first_name, mobile_no } = patient;
      // eslint-disable-next-line camelcase
      patient.first_name = first_name;
      // eslint-disable-next-line camelcase
      patient.mobile_no = mobile_no;
      this.$refs.patientProgress.viewPatientProgress(patient);
      this.patient = patient;
    },
    onViewProgressCancel() {
      this.patient = {};
    },
    viewResolvedNotes(patientDetails) {
      this.$refs.resolvedNotes.showResolvedNotes(patientDetails);
    },
    resetFilters() {
      this.filter = {
        day: "all",
        limit: 5,
        pageNo: 1,
        patient: "",
        careplan: "",
        searchValue: "",
        rowsPerPage: ""
      };
      this.carePlanSearchText = "";
      this.pateintSearchText = "";
      this.tableProps.page = 1;
      this.filter.day = "all";
      this.patientSearch = this.planSearch = "";
    },
    redirectToMessage(mrId) {
      const data = { mrId, isSelectedPatient: true };
      this.$store.dispatch('patient/setPatientDataToMsg', data);
      this.$router.push({ name: 'message.index' });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>

